import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import {
  FacebookLogo,
  InstagramLogo,
  PinterestLogo,
  MapPin,
} from 'phosphor-react'
import flatListToHierarchical from '../helpers/menu'
const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      wpMenu(name: { eq: "Footer Menu" }) {
        id
        menuItems {
          nodes {
            id
            url
            parentId
            label
          }
        }
      }
    }
  `)

  const footerItems = flatListToHierarchical(data.wpMenu.menuItems.nodes)

  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-brand-blue  block">
      <div className="w-full px-6 md:px-20 py-16 md:py-20">
        <div className="flex w-full justify-between flex-wrap items-center gap-y-4">
          <div className="flex gap-x-4 items-center justify-between md:justify-start w-full md:w-auto">
            <img
              src="/dm-white.svg"
              className="w-20 md:w-24 object-contain transition-all"
              alt="dm-logo"
            />
            <div className="flex">
              <a
                href="https://www.facebook.com/dmautoleasing/"
                rel="noreferrer"
                target="_blank"
              >
                <FacebookLogo size={30} color="white" className="mr-2"/>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.instagram.com/dmleasing/"
              >
                <InstagramLogo size={30} color="white" className="mx-2"/>
              </a>

              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.pinterest.com/dmleasing/"
              >
                <PinterestLogo size={30} color="white" className="ml-2"/>
              </a>
            </div>
          </div>
          <div className="flex flex-col gap-y-2">
            <p className="text-white font-bold flex gap-x-2 items-center text-sm">
              <MapPin size={16}/>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.google.com/maps/place/D%26M+Leasing+Dallas/@32.9688254,-96.8170529,14z/data=!4m5!1m2!2m1!1s17090+N.+Dallas+Pkwy,+Ste.+200,+Dallas,+TX%C2%A075248!3m1!1s0x864c2156263a049d:0xf31bae43fa89ce55"
              >
                Dallas: 17090 Dallas Pkwy, Ste. 200, Dallas, TX 75248
              </a>
            </p>
            <p className="text-white font-bold flex gap-x-2 items-center text-sm">
              <MapPin size={16}/>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.google.com/maps/place/D%26M+Leasing/@32.7512226,-97.3431849,17z/data=!3m1!4b1!4m5!3m4!1s0x864e80d2e8ec185b:0xae4128926eaecc56!8m2!3d32.7513127!4d-97.340999"
              >
                Fort Worth: 1400 W 7th St, Ste 200, Fort Worth, TX 76102
              </a>
            </p>
            <p className="text-white font-bold flex gap-x-2 items-center text-sm">
              <MapPin size={16}/>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.google.com/maps/place/D%26M+Leasing+Houston/@29.729085,-95.4556916,17z/data=!3m2!4b1!5s0x8640c10c75f8635d:0x48d53ac09bfe25d8!4m5!3m4!1s0x8640c16ad5e7c0ef:0x81b6ae0a8861bdca!8m2!3d29.729085!4d-95.4535029"
              >
                Houston: 4635 Southwest Freeway, Ste. 1000, Houston, TX. 77027
              </a>
            </p>
          </div>
        </div>

        <div
          className="footer-columns gap-y-8 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-6 flex-wrap gap-x-10 w-full justify-between mt-5 text-white">
          {footerItems.map(footerItem => (
            <div key={footerItem.label} className="flex flex-col">
              <p className="font-bold text-sm uppercase mb-4">
                {footerItem.label}
              </p>
              {footerItem.children.map(childItem => (
                <Link
                  className="font-light text-sm"
                  to={childItem.url}
                  key={childItem.id}
                >
                  {childItem.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="p-4 pb-0 bg-black w-full text-gray-400 flex justify-center gap-x-2 font-light">
        <Link to="/privacy-policy/">Privacy Policy</Link>
        <span className="text-white">|</span>
        <Link to="/online-down-payment-conditions/">Online Payment Terms</Link>
      </div>

      <div className="pb-4 bg-black w-full text-gray-400 flex justify-center gap-x-2 font-light">
        © {currentYear} D&M Auto Leasing. All Rights Reserved.
      </div>

    </footer>
  )
}

export default Footer
